"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ThresholdSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ThresholdSettings, _DomainObject_1$Domai);

  function ThresholdSettings(forecastCoordinatorConditionCheckEnabled) {
    var _this;

    _classCallCheck(this, ThresholdSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThresholdSettings).call(this));
    _this.forecastCoordinatorConditionCheckEnabled = forecastCoordinatorConditionCheckEnabled;
    return _this;
  }

  return ThresholdSettings;
}(DomainObject_1.DomainObject);

exports.ThresholdSettings = ThresholdSettings;

ThresholdSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ThresholdSettings.name);
  return {
    forecastCoordinatorConditionCheckEnabled: builder.bool('forecastCoordinatorConditionCheckEnabled')
  };
}();